<proffeo-ui-button
  [matMenuTriggerFor]="fabActions"
  variant="accent"
  fontIcon="add"
  class="md:hidden z-50 fixed bottom-5 right-5"
/>

<mat-menu #fabActions="matMenu">
  <button
    (click)="startSubtaskCreation()"
    class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
  >
    <mat-icon
      fontIcon="add"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.add-subtask' | translate }}</p>
  </button>

  <button
    (click)="openTimeReportDialog()"
    class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
  >
    <mat-icon
      fontIcon="timer"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.add-time-report' | translate }}</p>
  </button>

  <proffeo-file-drop
    (filesAdded)="onFabFilesAdded($event)"
    mode="ngContent"
  >
    <div
      class="w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
    >
      <mat-icon
        fontIcon="folder"
        class="group-hover:icon-white"
      />
      <p>{{ 'task-menu.add-file' | translate }}</p>
    </div>
  </proffeo-file-drop>
</mat-menu>

<mat-menu #taskActions="matMenu">
  <button
    (click)="startSubtaskCreation()"
    class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
  >
    <mat-icon
      fontIcon="add"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.add-subtask' | translate }}</p>
  </button>

  <button
    (click)="onCopyLink()"
    class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
  >
    <mat-icon
      fontIcon="content_copy"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.copy-link' | translate }}</p>
  </button>

  <button
    (click)="onCopyTaskNumber()"
    class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
  >
    <mat-icon
      fontIcon="content_copy"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.copy-number' | translate }}</p>
  </button>

  <button
    (click)="onCopyTask()"
    class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
  >
    <mat-icon
      fontIcon="folder_copy"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.copy-task' | translate }}</p>
  </button>

  <button
    (click)="openMoveTaskDialog()"
    class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
  >
    <mat-icon
      fontIcon="drive_file_move"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.move-task' | translate }}</p>
  </button>

  <button
    (click)="onOpenEditFinalCostDialog()"
    class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
  >
    <mat-icon
      fontIcon="paid"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.edit-final-cost' | translate }}</p>
  </button>
  <button
    (click)="onOpenEditContractCostDialog()"
    class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
  >
    <mat-icon
      fontIcon="description"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.edit-contract-cost' | translate }}</p>
  </button>
  <button
    (click)="onGeneratePdf()"
    class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
  >
    <mat-icon
      fontIcon="picture_as_pdf"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.generate-pdf' | translate }}</p>
  </button>

  @if (task().isLocked) {
    <button
      (click)="onUnlockTask()"
      class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
    >
      <mat-icon
        fontIcon="lock_open"
        class="group-hover:icon-white"
      />
      <p>{{ 'task-menu.unlock-task' | translate }}</p>
    </button>
  } @else {
    <button
      (click)="onLockTask()"
      class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
    >
      <mat-icon
        fontIcon="lock"
        class="group-hover:icon-white"
      />
      <p>{{ 'task-menu.lock-task' | translate }}</p>
    </button>
  }

  <button
    (click)="onDeleteTask()"
    class="group w-full py-3 gap-2 px-2 cursor-pointer flex items-center hover:bg-proffeo-accent hover:text-proffeo-on-action transition-150 transition-all"
  >
    <mat-icon
      fontIcon="delete"
      class="group-hover:icon-white"
    />
    <p>{{ 'task-menu.delete-task' | translate }}</p>
  </button>
</mat-menu>
